<div class="container">
  <app-breadcrumb currentPage="Minhas Fichas" routerCurrentPage="/ficha"></app-breadcrumb>
  <main id="main-container" class="main">
    <section class="col-xs-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
      <app-tipo-operacao (dadosSelecionados)="onDadosOperacaoChange($event)"></app-tipo-operacao>
      <app-quem-solicitou *ngIf="isShowSolicitante" (solicitanteChange)="onSolicitanteChange($event)"></app-quem-solicitou>
    </section>

    <a class="bt-go btn btn-full-orange main__next" [ngClass]="{'disabled': !isNext}" (click)="onclickNext()">Continuar
      <em class="fa fa-arrow-right mlBt"></em>
    </a>
  </main>
</div>
